import React, { ReactNode } from 'react'

interface ICardProps {
  children: ReactNode
}

export const Card = (props: ICardProps) => {
  return <dl className="def-lst def-lst--card">{props.children}</dl>
}
